document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
  initGaleriaProducto();
});

function initRevelado() {
  var elementos = document.querySelectorAll('.sol-reveal');
  if (!elementos.length) return;
  if (!('IntersectionObserver' in window)) {
    elementos.forEach(function (el) { el.classList.add('sol-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('sol-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  elementos.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-sol-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-sol-galeria-principal]');
  var miniaturas = galeria.querySelectorAll('[data-sol-galeria-mini]');
  if (!principal || !miniaturas.length) return;
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      principal.src = full;
      principal.alt = alt;
      miniaturas.forEach(function (m) { m.classList.remove('sol-mini-activa'); });
      mini.classList.add('sol-mini-activa');
    });
  });
}
